import React from 'react'
// import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function Utilities() {
    //  const [active, setActive] = useState("Safe Area");
    // const navigate = useNavigate();

    const clients = [
        {
            img: "/assets/services/weatherproof-hazardous-enclosures.svg",
            title: "Communication Gateway Enclosures",
            text: "Customised temperature-controlled enclosures with accessories in metal and polymers are designed to suit the stringent local weather conditions.",
            link: "/services/weatherproof-hazardous-enclosures"
        },
        {
            img: "/assets/services/instrumentation-control-cables.svg",
            title: "Weatherproof Enclosures",
            text: "Used to transmit precise low-energy data, signals, and power to monitor and automate critical systems like power grids, generating stations, and substations, ensuring safety, efficiency, and reliability.",
            link: "/services/instrumentation-control-cables"
        },
        {
            img: "/assets/services/cable-glands-lugs-cleats.svg",
            title: "Plugs &amp; Sockets",
            text: "Complete range of copper, aluminium and bi-metallic lugs for jointing and terminating cables along with compression glands are available for LV and MV applications.",
            link: "/services/cable-glands-lugs-cleats"
        },
        {
            img: "/assets/services/cable-ties-fixings.svg",
            title: "Cable Glands &amp; Lugs",
            text: "Available in stainless steel, nylon and special polymers to secure the movement of the cables when energised for cable routing & fixing.",
            link: "/services/cable-ties-fixings"
        },
        {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "Cable Cleats",
            text: "Used in process control systems to transport, measure and monitor fluids and gases such as water, steam and chemicals.",
            link: "/services/instrumentation-tubing-fittings"
        },
        {
            img: "/assets/services/identification-labelling-tube-fittings.svg",
            title: "Cable Ladder &amp; Trays",
            text: "For identification of wires, cables, cable trays and process pipes & equipment with regards to the direction of flow and content flowing within the pipes.",
            link: "/services/identification-labelling-tube-fittings"
        },
           {
            img: "/assets/services/identification-labelling-tube-fittings.svg",
            title: "Rigid &amp; Flexible Conduit",
            text: "For identification of wires, cables, cable trays and process pipes & equipment with regards to the direction of flow and content flowing within the pipes.",
            link: "/services/identification-labelling-tube-fittings"
        },
           {
            img: "/assets/services/identification-labelling-tube-fittings.svg",
            title: "Power &amp; Control Cables",
            text: "For identification of wires, cables, cable trays and process pipes & equipment with regards to the direction of flow and content flowing within the pipes.",
            link: "/services/identification-labelling-tube-fittings"
        },
           {
            img: "/assets/services/identification-labelling-tube-fittings.svg",
            title: "Cable Ties &amp; Fixings",
            text: "For identification of wires, cables, cable trays and process pipes & equipment with regards to the direction of flow and content flowing within the pipes.",
            link: "/services/identification-labelling-tube-fittings"
        },
        ,
           {
            img: "/assets/services/identification-labelling-tube-fittings.svg",
            title: "Identification &amp; Labelling Systems",
            text: "For identification of wires, cables, cable trays and process pipes & equipment with regards to the direction of flow and content flowing within the pipes.",
            link: "/services/identification-labelling-tube-fittings"
        },
    ];

    return (
        <>
        <Helmet>
    <title>
        Utilities Electrical & Cable Solutions UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides reliable electrical and cable solutions for utilities across the UAE, including power plants, substations, water and wastewater treatment facilities, enclosures, cables, cable glands, cleats, conduits and labelling systems."
    />

    <meta
        name="keywords"
        content="utilities electrical solutions UAE, utility cable management UAE, power plant electrical solutions UAE, substation cable solutions UAE, water treatment electrical solutions UAE, wastewater electrical solutions UAE, cable glands UAE, cable cleats UAE, cable trays UAE, power control cables UAE, cable labelling UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/utilities"
    />

    <meta
        property="og:title"
        content="Utilities Electrical & Cable Solutions UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Electrical, cable management and infrastructure solutions for power plants, substations, water and wastewater utilities across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/utilities"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Utilities</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Reliable infrastructure powering daily life and industry.
                    </p>
                </div>
            </div>

 
              <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Utilities</h2>
  <div className='line'></div>
                         <h3 className='text-left'>Utility services are key to the development of mankind and a modern civilization. With the soaring demand the utility services are under pressure 24x7, seeking strong support from the manufacturers and suppliers to provide uninterrupted supplies.
We as a team support power plant, substations, water, waste water treatment plants with certified quality products viz.</h3>

               </div>
               </div>
            <section className='lg:pt-[50px] pt-[30px] lg:pb-[10px] pb-[60px]'>

                <div className="grid lg:grid-cols-2 grid-cols-1 pb-[36px] lg:gap-[90px] gap-[30px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <div>
                      <div className="lg:sticky lg:top-[100px] self-start">
    <div className="h-[auto] mb-[15px] w-full justify-center flex items-center rounded-[12px] p-[22px]">
     
                            <img src="/assets/innerutility.png" alt="	Trusted cable management and termination solutions provider in the UAE" className='rounded-[12px]' />
                        </div>
                        </div>
                       
                    </div>
                    <div className='pt-[11px]'>
             
                       

 <ul className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-1">
  {[
  "Communication Gateway Enclosures",
  "Weatherproof Enclosures",
  "Plugs & Sockets",
  "Cable Glands & Lugs",
  "Cable Cleats",
  "Cable Ladder & Trays",
  "Rigid & Flexible Conduit",
  "Power & Control Cables",
  "Cable Ties & Fixings",
  "Identification & Labelling Systems",

  ].map((item, i) => (
    <li
      key={i}
      className="flex items-start gap-3 rounded-lg  bg-white px-4  transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed aplus">
        {item}
      </span>
    </li>
  ))}
</ul>
                         <Link to='/industries'>

            <button className='backbtn'>
              Back To Industries

            </button>
</Link>
                    </div>
                </div>
                {/* <div className='detail-div-p detail-div-p-2 max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <div className='detail-div-p-div'>
                        <h3>Weatherproof & Hazardous Area Enclosures</h3>
                        <p>Customised temperature-controlled enclosures with accessories in metal and polymers are designed to suit the stringent local weather conditions </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Instrumentation & Control Cables</h3>
                        <p> It is used to transmit precise low-energy data, signals, and power to monitor and automate critical systems like power grids, generating stations, and substations, ensuring safety, efficiency, and reliability. They enable communication between control devices and systems. </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Cable Glands, Lugs & Cleats</h3>
                        <p>Complete range of copper, aluminium and bi-metallic lugs for jointing and terminating cables along with compression glands are available for LV and MV applications. </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Cable Ties & Fixings</h3>
                        <p> Available in stainless steel, nylon and special polymers to secure the movement of the cables when energised for cable routing & fixing. </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Instrumentation Tubing & Tube Fittings </h3>
                        <p>These are used in process control systems to transport, measure and monitor fluids and gases such as water, steam and chemicals.  </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Identification & Labelling & Tube Fittings</h3>
                        <p>For identification of wires, cables, cable trays and process pipes & equipment’s with regards to the direction of flow and content flowing within the pipes. </p>
                    </div>
                </div> */}

            </section>
       

        </>
    )
}

export default Utilities